import {  Navigate } from 'react-router-dom';

const RouteGuard = ({ condition, redirectTo, children }) => {
   
    return condition ? children : <Navigate to={redirectTo} />;

};

export default RouteGuard;
